import { useSelector } from 'react-redux';
import withComponentName from '../../decorators/withComponentName';

import Styles from './styles.module.scss';
import trusted from '../../data/imagesTrusted';

const TrustedCompaniesLogosComponent = () => {
  const mainWidth = useSelector(({ common }) => (
    common.width
  ));

  const getImgSize = (trustedLogo) => {
    if (mainWidth >= 2800) {
      return {
        width: trustedLogo.bigSizes.width,
        height: trustedLogo.bigSizes.height,
      };
    }
    if (mainWidth > 1023) {
      return {
        width: trustedLogo.width,
        height: trustedLogo.height,
      };
    }
    if (mainWidth <= 1023 && mainWidth > 767) {
      return {
        width: trustedLogo.tabSizes.width,
        height: trustedLogo.tabSizes.height,
      };
    }
    return {
      width: trustedLogo.mobileSizes.width,
      height: trustedLogo.mobileSizes.height,
    };
  };

  return (
    <div className={Styles.logos}>
      {trusted.map(({ logo, id, ...trustedLogo }) => {
        const { width, height } = getImgSize(trustedLogo);
        return (
          <div className={Styles.logo} key={id}>
            <img
              width={width}
              height={height}
              src={logo}
              alt=""
            />
          </div>
        );
      })}
    </div>
  );
};

export default withComponentName(TrustedCompaniesLogosComponent);
